const host = process.env.NODE_ENV === 'development' ? 'localhost' : 'rexmas';

export const getDomain = () => window.location.host.split(`.${host}`)[0];

export const systemUserName = 'administrador';

export const switchOptions = {
  names: ['Administrador', 'Colaborador'],
  paths: ['rexmas.com', 'mirexmas.com'],
  active: [true, false],
};
